"use strict";
import axios from "axios";
import { getAuthHeaders } from "./UserTokenService";

export const getRequest = async (api_url, options) => {
  try {
    const response = await axios.get(api_url, {
      ...getAuthHeaders(),
      ...options
    });
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const postRequest = async (api_url, post_request) => {
  try {
    const response = await axios.post(api_url, post_request, getAuthHeaders());
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const patchRequest = async (api_url, post_request) => {
  try {
    const response = await axios.patch(api_url, post_request, getAuthHeaders());
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const getImage = async api_url => {
  try {
    return `${axios.defaults.baseURL}${api_url}`;
  } catch (e) {
    console.log(e);
  }
};

export const otherGetRequest = async (api_url) => {
  const response = await axios.get(api_url, getAuthHeaders());
  return response;
}

export const otherPostRequest = async (api_url, post_request) => {
  const response = await axios.post(api_url, post_request, getAuthHeaders());
  return response;
}
